import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type EmailType as SchemaEmailType } from '../schemas/EmailType';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const CurrentEmailContentType = '' as const;
export type CurrentEmailRequest = void;
export type CurrentEmailResponses = LinkCommonErrorResponses & {
    '200': {
        'application/json': string;
    };
};
export type CurrentEmailResponseSuccess = CurrentEmailResponses['200']['application/json'];
export type CurrentEmailSearchParams = {
    email_type: SchemaEmailType;
};
export type CurrentEmailPathParameters = undefined;
export const CurrentEmailUrl = '/email/current' as const;
export const CurrentEmailMethod = 'GET' as const;
export const getCurrentEmailUrl = (_params?: CurrentEmailPathParameters) => CurrentEmailUrl;
